import { unionSchema } from '@framework/validation';
import { AsyncExpressionType } from '../async/AsyncExpression.type';
import { FunctionExpressionType } from '../function/FunctionExpression.type';
import { ReferenceExpressionType } from '../reference/ReferenceExpression.type';
import { ValueExpressionType } from '../value/ValueExpression.type';
import { IAssignableExpression } from './IAssignableExpression';

const assignableExpressionSchemas = [
  ValueExpressionType.schema,
  ReferenceExpressionType.schema,
  FunctionExpressionType.schema,
  AsyncExpressionType.schema,
];

/**
 * Validatore per i campi di configurazione delle espressioni assegnabili.
 * Il campo ha un default a `ValueExpressionType`.
 */
export const DefaultAssignableExpressionSchema =
  getDefaultAssignableExpressionSchema(ValueExpressionType.schema.getDefault());

/**
 * Funzione che genera il validatore per i campi di configurazione delle espressioni assegnabili.
 * Permette di definire un default.
 */
export function getDefaultAssignableExpressionSchema(
  defaultValue: IAssignableExpression | undefined = undefined,
) {
  return unionSchema<IAssignableExpression>(
    assignableExpressionSchemas,
    undefined,
    schema =>
      // imposto il value expression come default
      schema
        .default(
          ValueExpressionType.schema.cast(defaultValue, { assert: false }),
        )
        .meta({ expression: 'assignable' })
        .label('Valore di default'),
  );
}
